// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-39819d6c] .primary .modal-body{background-color:#e9f7fb}.otp-input-container[data-v-39819d6c]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:.5rem}.otp-input[data-v-39819d6c]{width:2rem;height:2rem;text-align:center;font-size:1.5rem;border:1px solid #ccc;border-radius:4px;outline:none}.otp-input[data-v-39819d6c]:focus{border-color:#007bff;-webkit-box-shadow:0 0 0 2px rgba(0,123,255,.25);box-shadow:0 0 0 2px rgba(0,123,255,.25)}", ""]);
// Exports
module.exports = exports;
